import { render, staticRenderFns } from "./ViewForum.vue?vue&type=template&id=b339dd72"
import script from "./ViewForum.vue?vue&type=script&lang=js"
export * from "./ViewForum.vue?vue&type=script&lang=js"
import style0 from "./ViewForum.vue?vue&type=style&index=0&id=b339dd72&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports